var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InventoryWidgetGraph',{attrs:{"graphData":_vm.graphData,"isLoading":false,"prevGraphData":_vm.prevGraphData,"title":"Список описей дел"}})}
var staticRenderFns = []

export { render, staticRenderFns }